export default "__VITE_ASSET__DKZyHOYv__"